// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a12584e5","239":"7f19e3cd","453":"fe3b160c","455":"c110a423"}[chunkId] + ".chunk.js";
};